import { Command } from 'commander'
import { createClient } from '../../client.js'
import { handleError } from '../../lib/errors.js'
import { isQuiet, printQuiet, printJson, printKeyValue } from '../../output.js'

export const projectsGetCommand = new Command(`get`)
  .description(`Show project details`)
  .argument(`<id>`, `Project ID`)
  .action(async (projectId: string) => {
    const json = projectsGetCommand.parent?.parent?.opts().json ?? false
    try {
      const client = createClient()
      const result = await client.projects.get({ projectId })

      if (isQuiet()) {
        printQuiet(result.id)
        return
      }

      if (json) {
        printJson(result)
      } else {
        printKeyValue([
          [`ID:`, result.id],
          [`Name:`, result.name],
          [`Workspace:`, result.workspaceId],
          [`Created:`, result.createdAt],
        ])
      }
    } catch (error) {
      handleError(error, json)
    }
  })
